import React, { useCallback } from "react";
import "./Instructions.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCloudDownloadAlt, faEllipsisH
} from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import lotus from './assets/lotus-yellow.png'
import clipBoard from './assets/clipboard.png'
import { storage } from './firebase/index'


const iconSize = "35px";
const iconColor = "#707070";

const downloadIcon = (
  <FontAwesomeIcon
    style={{ fontSize: iconSize, color: iconColor, padding: "10px" }}
    icon={faCloudDownloadAlt}
  />
);

const horizontalDots = (
  <FontAwesomeIcon icon={faEllipsisH}></FontAwesomeIcon>
)

const clipBoardIcon = (
    <img src={clipBoard} style={{height: "35px", width: "35px",marginRight: "30px", marginLeft:"30px"}}></img>
  )



function Instructions() {
  const history = useHistory();
  const goToRoute = useCallback((path) =>  { console.log(path); history.push(path); }, [history]);

  const downloadPdf = (async () => {
    const pdfUrl = await storage.ref('Ivris Checklista Anteckningar.pdf').getDownloadURL();
    window.open(pdfUrl, "_blank")
  })
  return (
    <div className="main-container">
      <div className="main-area">
        <div className="page-title">Hur funkar det?</div>

        <div className="info-text" style={{width: "50%"}}>
        Checklistan är ett verktyg som stödjer utveckling av idéer för introduktion av välfärdsteknik. Med idéer menar vi alla initiativ som kan leda till nya eller förbättrade sätt att arbeta med välfärdstjänster med hjälp av teknik. Vem som helst som ser ett behov, en möjlighet, eller en fråga kan ta initiativ. 
        Samarbete mellan många aktörer, inom och utanför en organisation, behövs när välfärdsteknik introduceras. Det handlar nämligen om att förändra arbetssättet snarare än att börja använda en teknisk pryl. Det är därför viktigt att ta hänsyn till många faktorer. Checklistan hjälper med att samla alla relevanta aktörer för att tillsammans definiera behoven, problemen, nyttorna och tillgängliga resurser. Checklistan är också tänkt att fungera som ett komplement till andra planerings- och utvecklingsmodeller (t ex Nyttorealisering). Du kan fritt använda valda delar av checklistan för att komplettera eller förbättra en befintlig modell. Hur checklistan fungerar:

        </div>
        <div style={{display: "flex"}}>
          <div style={{width: "30%", paddingRight: "80px"}}>
            <div className="list-title">1. Ett verktyg för att påbörja en process.</div>
            <div className="info-text">
              Checklistan utgår ifrån den enkla principen “glöm inte”. Det finns fyra steg genom vilka idén utvecklas innan det är dags för eventuell implementering och uppföljning. Varje steg erbjuder ett antal frågor som vägleder dig så att ingen viktig aktör eller aktivitet glöms bort. 
              Några råd (se {horizontalDots} ) ges dig för att hjälpa dig svara på frågorna. När en fråga är besvarad, kan du bocka av den och gå vidare med de andra frågorna. När alla frågor är besvarade (och avbockade), är du klar med en ”prototyp”. Med prototyp menar vi en mer konkret och detaljerad version av idén som du kan dokumentera i din egen organisations system. För det kan du med fördel använda den PDF som finns för att ta anteckningar. 
              Varje steg avslutas med ett beslutsalternativ: fortsätta med nästa steg, gå tillbaka till Steg 1 och omarbeta, eller avsluta.
            </div>
          </div>
          <div style={{width: "38%"}}>
            <div className="list-title">2. Ett icke-linjärt verktyg.</div>
            <div className="info-text">
              Du behöver inte följa någon specifik ordning när du arbetar med frågorna; verktyget är tänkt 
              stödja utveckling av en idé genom att dra nytta av det som kommer upp under resans gång.
            </div>
            <div className="list-title">3. En pågående lärandeprocess snarare än ett kontrollverktyg.</div>
            <div className="info-text">
              Det är sannolikt att behov, tänkta användare, lösningar, beslutfattare, nyttor förändras under resan från start 
              till implementering. Detta är inte tecken på misslyckande. Utan det visar på att anpassning behöver ske medan 
              processen fortgår för att kunna matcha en föränderlig och komplex verklighet. 
            </div>
            <div className="list-title">4. En process för reflektion.</div>
            <div className="info-text">
              Målen, deltagare, användare och visioner diskuteras återkommande under hela processen.
            </div>
          </div>
        </div>

        <div style={{display: "flex", placeContent: "space-between"}}>
          <span style={{margin: "auto 0px", fontFamily: "Avenir Heavy"}}>För anteckningar</span>
          {clipBoardIcon}
          <button style={{paddingLeft: "30px", paddingRight: "30px"}} className="nav-btn" onClick={() => downloadPdf()}>HÄMTA PDF</button>
        </div>


        <div className="top-right-nav">
          <img style={{margin: "0px auto"}} height="98px" width="151px" src={lotus}></img>
          <button className="nav-btn" onClick={() => goToRoute('/checklista')}>STARTA CHECKLISTAN</button>

        </div>

      </div>

    </div>
  );
}

export default Instructions;
